export default [
    {
        path: '/student-galleries-bk',
        name: 'student-gallery-bk',
        meta: { requiresAuth: true },
        component: () => import('@/pages/student-gallery-bk/index.vue')
    }
]
